import { createContext } from 'react';
export var PanoramaContext = createContext(null);
export var PanoramaContextConsumer = PanoramaContext.Consumer;
export var PanoramaProvider = PanoramaContext.Provider;
//# sourceMappingURL=PanoramaProvider.js.map